import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(theme => ({
	constainerDivision: {
		height: 56,
		alignItems: "center",
		justifyContent: "space-between"
	},
	progressRoot: {
		height: theme.spacing(2),
		borderRadius: 4
	},
	progressTrack: {
		backgroundColor: themeColors.colors.primary[100]
	},
	progressBar: {
		backgroundColor: themeColors.getPrimaryColor()
	},
	progressTrackNegative: {
		backgroundColor: themeColors.colors.error[100]
	},
	progressBarNegative: {
		backgroundColor: themeColors.colors.error[600]
	},
	linkIcon: {
		width: "12px",
		height: "12px",
		marginLeft: 4,
		verticalAlign: "middle"
	},
	infoIcon: {
		fontSize: 16,
		color: themeColors.colors.system.gray[400]
	}
}))

export default useStyles
